import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ViewSearchBox from 'components/ViewSearchBox';
import ViewHorizontalNavigation from 'components/ViewHorizontalNavigation';
import ViewEventList from 'containers/ViewEventList';
import ViewSpinner from 'components/ViewSpinner';
import ViewListToolbar from 'components/ViewListToolbar';
import 'css/HomePage.scss';
import * as UiSportLiveActions from 'actions/UiSportLiveActions';
import * as EventObjectActions from 'actions/EventObjectActions';
import * as LiveEventsActions from 'actions/LiveEventsActions';
import * as VaixEventsActions from 'actions/VaixEventsActions';
import * as TrackingEventActions from 'actions/TrackingEventActions';
import { ModelService } from 'utils/ModelService';
import { browserHistory } from 'react-router';
import {
    EVENT_STATUS,
    LIVE_COMPETITORS_ORDER,
    SPORT_GROUPS_ID,
    SPORTS,
    ANBEFALET,
    ANBEFALET_SPORT_ID,
} from 'constants/appConfig';
import TerminalRestService from 'utils/TerminalRestService';
import ViewPageToolbar from 'components/ViewPageToolbar';
import { sortEventsByCompetitionAndGroupPriority } from 'utils/Helper';
import { detectMobile, isTerminal, scrollToTop } from 'utils/UiHelper';
import SportRadarWidget from 'components/SportRadarWidget';
import HorseRacingStream from 'features/HorseRacingStream';
import GroupEventItem from '../EventItemContainer/GroupEventItem';
import { SPORTS_ALLOW_MATCH_CENTER } from '../../constants/allowMatchCenter';
import VAIXService from '../../utils/VAIXService';
import {
    getArrayOfNumbersFromStringInArrayOfObjects,
    sortEventsByVaixPriority,
    sortEventsByVaixRecommendationAndOurPriority,
} from '../../utils/Helper';
import WidgetSkeleton from '../../components/SkeletonUI/WidgetSkeleton/WidgetSkeleton';
import HorizontalNavigationSkeleton from '../../components/SkeletonUI/HorizontalNavigationSkeleton/HorizontalNavigationSkeleton';
import SearchFieldSkeleton from '../../components/SkeletonUI/SearchFieldSkeleton/SearchFieldSkeleton';
import ViewEventListSkeleton from '../../components/SkeletonUI/ViewEventListSkeleton/ViewEventListSkeleton';

const SectionLiveTab = (props) => {
    const liveGroupsIdsOrder = [
        SPORT_GROUPS_ID.INTERNATIONAL,
        SPORT_GROUPS_ID.INTERNATIONAL_CLUB,
    ];
    const liveCompetitionIdsOrder = LIVE_COMPETITORS_ORDER;
    const liveScoreStatuses = ['ended', 'interrupted', 'not_started'];
    const [livePopular, setLivePopular] = useState([]);
    const activeSportId = props.activeSportId;
    const [updateVaixData, setUpdateVaixData] = useState(false);
    const [sortingEventsIsPending, setSortingEventsIsPending] = useState(false);
    const [
        vaixDataForSortingBySportType,
        setVaixDataForSortingBySportType,
    ] = useState([]);
    const [initialFetchDone, setInitialFetchDone] = useState(false);
    const [contentWithSortingReady, setContentWithSortingReady] = useState(
        false
    );
    const isMobile = detectMobile();

    const isTWA = Boolean(JSON.parse(window.localStorage.getItem('isTWA')));

    useEffect(() => {
        isTerminal() && getPopularLiveEvents();

        isTerminal() && props.liveEventsActions.getLiveEvents();

        props.vaixEventsActions.getVaixLiveFavoriteEventsIds(
            props.auth?.user?.userId,
            props.vaixEvents.vaixLiveFavoriteEventsIds
        );
        setTimeout(() => {
            props.vaixEventsActions.getVaixLiveNavigationOrder(
                props.auth?.user?.userId
            );
        }, 10);

        scrollToTop();
        return () => {
            if (props.activeSportId !== ANBEFALET_SPORT_ID) {
                props.uiSportLiveActions.setActiveSportId(0);
            }
        };
    }, []);

    const updateWidgetEventIdState = () => {
        const [first] = getLiveEventsIdListWithExternalIds();
        const popular = getLiveEventsIdListWithExternalIds().find((id) =>
            livePopular.some((popularId) => popularId === String(id))
        );
        return popular || first;
    };

    const getWidget = (activeSportId) => {
        let externalId = updateWidgetEventIdState();
        if (activeSportId === ANBEFALET_SPORT_ID) {
            if (
                props.liveEvents?.vaixFavoriteEventsFetched &&
                props.liveEvents?.vaixFavoriteEvents[0] &&
                props.liveEvents?.vaixFavoriteEvents[0]?.sportId &&
                SPORTS_ALLOW_MATCH_CENTER.includes(
                    props.liveEvents?.vaixFavoriteEvents[0]?.sportId
                )
            ) {
                return (
                    <div className="secondary-block">
                        <div className="secondary-block-content">
                            <ViewPageToolbar
                                title={getWidgetLabel(activeSportId)}
                            />
                            {props.liveEvents.vaixFavoriteEventsFetched && (
                                <SportRadarWidget
                                    externalId={
                                        props.liveEvents.vaixFavoriteEvents[0]
                                            ?.externalId
                                    }
                                    isLive={
                                        props.liveEvents.vaixFavoriteEvents[0]
                                            ?.live
                                    }
                                />
                            )}
                        </div>
                    </div>
                );
            }
        } else {
            if (
                SPORTS_ALLOW_MATCH_CENTER.includes(activeSportId) &&
                props.liveEvents.data &&
                props.liveEvents.data[activeSportId] &&
                props.liveEvents.data[activeSportId][externalId] &&
                props.liveEvents.data[activeSportId][externalId].externalId
            ) {
                return (
                    <div className="secondary-block">
                        <div className="secondary-block-content">
                            <ViewPageToolbar title={getWidgetLabel()} />
                            {props.liveEvents.fetched && (
                                <SportRadarWidget
                                    externalId={
                                        props.liveEvents?.data[activeSportId][
                                            externalId
                                        ]?.externalId
                                    }
                                    isLive={
                                        props.liveEvents?.data[activeSportId][
                                            externalId
                                        ]?.live
                                    }
                                />
                            )}
                        </div>
                    </div>
                );
            } else if (
                activeSportId === SPORTS.HESTESPORT &&
                props.auth?.user?.userId
            ) {
                return (
                    <div className="secondary-block">
                        <div className="secondary-block-content">
                            <ViewPageToolbar title={getWidgetLabel()} />
                            <HorseRacingStream />
                        </div>
                    </div>
                );
            }
        }
    };

    useEffect(
        () => {
            if (
                props.vaixEvents.navigationOrderIdsFetched &&
                props.liveEvents.vaixFavoriteEventsFetched
            ) {
                if (props.activeSportId > 0) {
                    props.uiSportLiveActions.setActiveSportId(
                        props.activeSportId
                    );
                } else if (
                    !props.activeSportId ||
                    props.activeSportId === 0 ||
                    !isLiveEventsIncludeActiveSportId()
                ) {
                    setDefaultActiveSportId();
                }
            }
        },
        [
            props.vaixEvents.navigationOrderIdsFetched,
            props.liveEvents.vaixFavoriteEventsFetched,
        ]
    );

    useEffect(
        () => {
            props.vaixEventsActions.getVaixLiveFavoriteEventsIds(
                props.auth?.user?.userId,
                props.vaixEvents.vaixLiveFavoriteEventsIds
            );
            props.vaixEventsActions.getVaixLiveNavigationOrder(
                props.auth?.user?.userId
            );
            getContentWithSorting(activeSportId, false);
        },
        [props.auth?.user?.userId]
    );

    const checkFetchCondition = () => {
        return (
            props.vaixEvents.navigationOrderIdsFetched &&
            checkVaixFavoriteEventsFetching() &&
            props.sportTree.fetched
        );
    };

    const checkVaixFavoriteEventsFetching = () => {
        return (
            props.liveEvents.vaixFavoriteEventsFetched ||
            props.vaixEvents.vaixLiveFavoriteEventsIdsFetched
        );
    };

    useEffect(
        () => {
            //events for live section Anbefalede
            if (props.vaixEvents.vaixFavoriteEventsShouldBeUpdated) {
                if (props.vaixEvents.vaixLiveFavoriteEventsIds.length > 0) {
                    props.liveEventsActions.addVaixLiveFavoriteEvents(
                        props.vaixEvents.vaixLiveFavoriteEventsIds
                    );
                    if (activeSportId === ANBEFALET_SPORT_ID) {
                        getOldFlow();
                    }
                    props.vaixEventsActions.updateVaixLiveEventsComponentStatus(
                        false
                    );
                } else {
                    props.vaixEventsActions.updateVaixLiveEventsComponentStatus(
                        false
                    );
                    props.liveEventsActions.setLiveVaixFavoriteFetchedStatus(
                        true
                    );
                }
            }
        },
        [props.vaixEvents.vaixFavoriteEventsShouldBeUpdated]
    );

    useEffect(
        () => {
            if (activeSportId !== ANBEFALET_SPORT_ID || activeSportId !== 0) {
                setUpdateVaixData(true);
            }
            getWidget(activeSportId);
            setContentWithSortingReady(false);
        },
        [props.activeSportId]
    );

    useEffect(
        () => {
            setSortingEventsIsPending(false);
        },
        [vaixDataForSortingBySportType]
    );

    useEffect(
        () => {
            if (!initialFetchDone && checkFetchCondition()) {
                setInitialFetchDone(true);
            }
        },
        [
            props.vaixEvents.navigationOrderIdsFetched,
            props.liveEvents.vaixFavoriteEventsFetched,
            props.vaixEvents.vaixLiveFavoriteEventsIdsFetched,
            props.sportTree.fetched,
        ]
    );

    const isLiveEventsIncludeActiveSportId = () => {
        if (props.activeSportId && props.liveEvents.data) {
            return Object.keys(props.liveEvents.data).includes(
                String(props.activeSportId)
            );
        }
        return false;
    };

    const setDefaultActiveSportId = () => {
        if (checkFetchCondition()) {
            if (
                Object.keys(props.liveEvents.data).length > 0 &&
                props.liveEvents.data[ANBEFALET_SPORT_ID] &&
                Object.keys(props.liveEvents.data[ANBEFALET_SPORT_ID]).length >
                    0
            ) {
                props.uiSportLiveActions.setActiveSportId(ANBEFALET_SPORT_ID);
            } else {
                const filtered = getFilteredLiveSports();
                if (
                    props.vaixEvents.navigationOrderIds.length > 0 &&
                    filtered.length > 0
                ) {
                    let firstId = [];
                    props.vaixEvents.navigationOrderIds.map((id) =>
                        filtered.map((sport) => {
                            if (sport?.id === id) {
                                firstId.push(id);
                            }
                        })
                    );
                    props.uiSportLiveActions.setActiveSportId(firstId[0]);
                } else {
                    if (filtered[0]?.id) {
                        props.uiSportLiveActions.setActiveSportId(
                            filtered[0].id
                        );
                    }
                }
            }
        }
    };

    const horizontalNavClickHandler = (item) => {
        setContentWithSortingReady(false);
        props.uiSportLiveActions.setActiveSportId(item.id);
    };

    const onSearchTextHandler = (searchText) => {
        props.uiSportLiveActions.search(searchText);
    };

    const backBtnHandler = () => {
        browserHistory.push('/sport/');
    };

    const getLiveEventsIdListWithExternalIds = () => {
        if (
            !props.liveEvents.fetched ||
            !props.activeSportId ||
            !props.liveEvents.data[props.activeSportId]
        ) {
            return [];
        }

        return Object.values(props.liveEvents.data[props.activeSportId])
            .filter((item) => item.externalId > 0 && item.marketList)
            .map((item) => item.eventId);
    };

    const getPopularLiveEvents = () => {
        TerminalRestService.getLivePopularEvents((res) => {
            setLivePopular(
                res.filter((item) => item).map((event) => String(event.eventId))
            );
        });
    };

    const getFilteredLiveSports = () => {
        if (!props.liveEvents.fetched || !props.sportTree.fetched) {
            return [];
        }

        return props.sportTree.sportData.filter(
            (item) =>
                props?.liveEvents?.data?.[item?.id] &&
                Object.values(props?.liveEvents?.data?.[item.id]).some(
                    (event) => {
                        const hasCompetitionId = item?.itemList?.some(
                            (groupValue) =>
                                groupValue.itemList.some(
                                    (tournamentValue) =>
                                        tournamentValue?.id ===
                                        event.competitionId
                                )
                        );

                        return (
                            (event?.status === EVENT_STATUS.IN_PROGRESS ||
                                event?.status === EVENT_STATUS.PAUSE) &&
                            event?.liveScore &&
                            event?.liveScore?.homeScore &&
                            liveScoreStatuses.indexOf(
                                event?.liveScore?.status
                            ) < 0 &&
                            hasCompetitionId
                        );
                    }
                )
        );
    };

    const getWidgetLabel = (activeSportId) => {
        if (activeSportId === ANBEFALET_SPORT_ID) {
            return `Kamp oversigt (${
                props.liveEvents?.vaixFavoriteEvents[0]?.eventName
            })`;
        } else {
            if (!props.eventObject.fetched || props.eventObject.pending) {
                return 'Kamp oversigt';
            }
            return `Kamp oversigt (${props.eventObject.data.eventName})`;
        }
    };

    const spinner = <ViewSpinner />;

    const liveCasino = {
        id: 'live_casino',
        name: 'Live casino',
    };

    const getNavigation = () => {
        const filteredSports = getFilteredLiveSports();
        let sortedSports = [];
        let sortedSportsIds = [];

        if (props.vaixEvents.navigationOrderIds.length > 0) {
            props.vaixEvents.navigationOrderIds.forEach((id) => {
                let eventId = id === 137 ? 1 : id;
                let filteredSportByVaix = filteredSports.find(
                    (sport) => sport.id === eventId
                );
                if (
                    filteredSportByVaix &&
                    !sortedSports.includes(filteredSportByVaix)
                ) {
                    sortedSportsIds.push(filteredSportByVaix.id);
                    sortedSports.push(filteredSportByVaix);
                }
            });
            filteredSports.forEach((item) => {
                if (!sortedSportsIds.includes(item.id)) {
                    sortedSports.push(item);
                }
            });
        } else {
            sortedSports = [...filteredSports];
        }
        sortedSports = isTWA ? sortedSports : [...sortedSports, liveCasino];

        if (props.liveEvents.vaixFavoriteEvents.length > 0) {
            let anbefalet = {
                count: props.liveEvents.vaixFavoriteEvents.length,
                countLive: props.liveEvents.vaixFavoriteEvents.length,
                id: ANBEFALET_SPORT_ID,
                itemList: props.liveEvents.vaixFavoriteEvents,
                name: ANBEFALET,
                priority: 1,
                skip: false,
                top: 0,
                type: 1,
            };
            sortedSports.unshift(anbefalet);
        }

        const updatedArray = sortedSportsIds.map((id) => ({
            id: `sr:sport:${id}`,
        }));
        const externalIds = props.vaixEvents?.vaixLiveFavoriteEventsIds.map(
            (event) => ({
                id: `sr:match:${event}`,
            })
        );
        if (
            updatedArray.length > 0 &&
            !props.vaixEvents.pending &&
            props.vaixEvents.vaixFavoriteEventsShouldBeUpdated &&
            props.vaixEvents.vaixLiveFavoriteEventsIds.length > 0
        ) {
            props.trackImpressionEvent(
                'impressions:events',
                externalIds,
                'sr-widget:livepagebetrecommendation.eventlist:recommended',
                '/live',
                props.auth?.user?.userId || 0
            );
            props.trackImpressionSport(
                'impressions:sports',
                updatedArray,
                'sr:widget:livepagesport:recommended',
                '/live',
                props.auth?.user?.userId || 0
            );
        }

        return props.sportTree.fetched &&
            (sortedSports.length > 0 || filteredSports.length > 0) ? (
            <ViewHorizontalNavigation
                showBackBtn={true}
                backBtnHandler={() => {
                    browserHistory.push('/sport/');
                }}
                mode="live"
                items={sortedSports.length > 0 ? sortedSports : filteredSports}
                trackClickEvent={props.trackClickEvent}
                trackImpressionEvent={props.trackImpressionEvent}
                userId={props.auth.user?.userId}
                sortedSportsIds={sortedSportsIds}
                clickHandler={horizontalNavClickHandler}
                selectedId={String(activeSportId)}
            />
        ) : null;
    };

    const getContentWithSorting = (activeSportId) => {
        if (!sortingEventsIsPending) {
            if (activeSportId !== ANBEFALET_SPORT_ID && activeSportId !== 0) {
                if (
                    props.liveEvents.updateDataWithVaixSorting ||
                    updateVaixData
                ) {
                    setSortingEventsIsPending(true);
                    VAIXService.getVaixPopularEventBySportId(
                        props.auth.user?.userId || 0,
                        -5,
                        100,
                        activeSportId
                    )
                        .then((res) => {
                            const { data } = res;
                            !contentWithSortingReady &&
                                setContentWithSortingReady(true);
                            if (props.liveEvents.updateDataWithVaixSorting) {
                                props.liveEventsActions.updateLiveDataWithVaixSorting(
                                    false
                                );
                            }
                            if (data && data.length > 0) {
                                data.filter((item) => item.status === 'live');
                                let sortedData = sortEventsByVaixPriority(data);
                                setVaixDataForSortingBySportType(sortedData);

                                setUpdateVaixData(false);
                                return getLiveListViewAndFavoriteEvents(
                                    sortedData,
                                    true
                                );
                            } else {
                                setVaixDataForSortingBySportType([]);
                                setUpdateVaixData(false);
                                return getOldFlow();
                            }
                        })
                        .catch(() => {
                            setVaixDataForSortingBySportType([]);
                            setUpdateVaixData(false);
                            return getOldFlow();
                        });
                } else {
                    if (updateVaixData) {
                        setUpdateVaixData(false);
                    }

                    return getLiveListViewAndFavoriteEvents(
                        vaixDataForSortingBySportType &&
                        vaixDataForSortingBySportType.length > 0
                            ? vaixDataForSortingBySportType
                            : []
                    );
                }
            } else {
                return getOldFlow();
            }
        }
    };

    const getLiveListViewAndFavoriteEvents = (vaixData, trackData = false) => {
        if (
            vaixData &&
            vaixData.length > 0 &&
            activeSportId !== ANBEFALET_SPORT_ID &&
            Object.keys(props.liveEvents.data).length > 0
        ) {
            let externalEventIds = getArrayOfNumbersFromStringInArrayOfObjects(
                vaixData,
                'event_id'
            );

            let eventsFilteredByActiveSportId = [];

            for (const eventId in props.liveEvents.data[activeSportId]) {
                eventsFilteredByActiveSportId.push(
                    props.liveEvents.data[activeSportId][eventId]
                );
            }

            let sortedEventsByVaix = sortEventsByVaixRecommendationAndOurPriority(
                eventsFilteredByActiveSportId,
                externalEventIds,
                trackData,
                props.auth?.user?.userId || 0
            );

            let {
                sortedTypeOfSports,
                groupedEvents,
            } = ModelService.getVaixModelBySportId(sortedEventsByVaix);

            !contentWithSortingReady && setContentWithSortingReady(true);
            return sortedTypeOfSports.map((group, key) => (
                <GroupEventItem
                    events={groupedEvents[group]}
                    key={`${key}_${groupedEvents[group].sport}_${group}`}
                    showFavorites={false}
                    trackClickEvent={props.trackClickEvent}
                    trackImpressionEvent={props.trackImpressionEvent}
                    isLive
                    userId={props.auth.user?.userId}
                    trackEvents
                />
            ));
        } else {
            return getOldFlow();
        }
    };

    const getOldFlow = () => {
        if (props.liveEvents.fetched && props.liveEvents.data) {
            if (!props.searchText) {
                const allEvents = {};

                if (activeSportId && props.liveEvents.data[activeSportId]) {
                    Object.keys(props.liveEvents.data[activeSportId]).forEach(
                        (eventId) => {
                            if (
                                (props.liveEvents.data[activeSportId][eventId]
                                    .status === EVENT_STATUS.IN_PROGRESS ||
                                    props.liveEvents.data[activeSportId][
                                        eventId
                                    ].status === EVENT_STATUS.PAUSE) &&
                                props?.liveEvents?.data?.[activeSportId]?.[
                                    eventId
                                ]?.liveScore?.homeScore &&
                                liveScoreStatuses.indexOf(
                                    props?.liveEvents?.data?.[activeSportId]?.[
                                        eventId
                                    ]?.liveScore.status
                                ) < 0
                            ) {
                                allEvents[eventId] =
                                    props.liveEvents.data[activeSportId][
                                        eventId
                                    ];
                            }
                        }
                    );
                }

                if (Object.keys(allEvents).length > 0) {
                    let {
                        sortedTypeOfSports,
                        groupedEvents,
                    } = ModelService.getVaixModelBySportId(
                        props.liveEvents.vaixFavoriteEvents
                    );
                    !contentWithSortingReady &&
                        setContentWithSortingReady(true);
                    return activeSportId !== SPORTS.FLOORBALL ? (
                        activeSportId === ANBEFALET_SPORT_ID ? (
                            sortedTypeOfSports.map((group, key) => (
                                <GroupEventItem
                                    events={groupedEvents[group]}
                                    key={`${key}_anbefalet_${group}`}
                                    showFavorites={false}
                                    trackClickEvent={props.trackClickEvent}
                                    trackImpressionEvent={
                                        props.trackImpressionEvent
                                    }
                                    isLive
                                    userId={props.auth.user?.userId}
                                    trackEvents
                                />
                            ))
                        ) : (
                            <ViewEventList
                                danmarkItems={props.danmarkItems}
                                events={ModelService.getSportTree(
                                    props.sportTree.sportData,
                                    allEvents,
                                    'array',
                                    0,
                                    null,
                                    'sportId'
                                )}
                                showFavorites="true"
                            />
                        )
                    ) : (
                        <ViewEventList
                            danmarkItems={props.danmarkItems}
                            events={ModelService.getSportTreeWithGroupedByCompetitions(
                                props.sportTree.sportData,
                                sortEventsByCompetitionAndGroupPriority(
                                    Object.values(allEvents),
                                    liveCompetitionIdsOrder,
                                    liveGroupsIdsOrder
                                ),
                                'array',
                                0
                            )}
                            showFavorites="true"
                        />
                    );
                } else {
                    !contentWithSortingReady &&
                        setContentWithSortingReady(true);
                    return (
                        <ViewEventList
                            danmarkItems={props.danmarkItems}
                            events={[]}
                            showFavorites="true"
                        />
                    );
                }
            } else {
                const filteredEvents = {};

                if (activeSportId) {
                    Object.keys(props.liveEvents.data[activeSportId]).map(
                        (eventId) => {
                            const item =
                                props.liveEvents.data[activeSportId][eventId];

                            if (
                                (item.homeTeam
                                    .toLowerCase()
                                    .indexOf(props.searchText.toLowerCase()) >
                                    -1 ||
                                    item.awayTeam
                                        .toLowerCase()
                                        .indexOf(
                                            props.searchText.toLowerCase()
                                        ) > 0) &&
                                item.liveScore &&
                                item.liveScore.homeScore !== null &&
                                (item.status === 1 || item.status === 2)
                            ) {
                                filteredEvents[eventId] = item;
                            }

                            return eventId;
                        }
                    );
                }

                !contentWithSortingReady && setContentWithSortingReady(true);

                return activeSportId !== SPORTS.FLOORBALL ? (
                    <ViewEventList
                        events={ModelService.getSportTree(
                            props.sportTree.sportData,
                            filteredEvents,
                            'array',
                            0,
                            null,
                            'sportId'
                        )}
                        showFavorites="true"
                    />
                ) : (
                    <ViewEventList
                        events={ModelService.getSportTreeWithGroupedByCompetitions(
                            props.sportTree.sportData,
                            sortEventsByCompetitionAndGroupPriority(
                                Object.values(filteredEvents),
                                liveCompetitionIdsOrder,
                                liveGroupsIdsOrder
                            ),
                            'array',
                            0
                        )}
                        showFavorites="true"
                    />
                );
            }
        }
    };

    const selectedSport =
        props.sportTree.fetched &&
        props.sportTree.sportMap &&
        props.sportTree.sportMap[activeSportId]
            ? props.sportTree.sportMap[activeSportId].name
            : activeSportId === ANBEFALET_SPORT_ID
                ? `${ANBEFALET}`
                : 'Live';

    const searchInputView = !initialFetchDone ? (
        <div className="search-input-skeleton-container">
            <SearchFieldSkeleton />
        </div>
    ) : isTerminal() ? (
        <ViewSearchBox
            onSearchTextHandler={onSearchTextHandler}
            value={props.searchText}
        />
    ) : (
        <ViewSearchBox
            onSearchTextHandler={onSearchTextHandler}
            showBackBtn={isMobile}
            backBtnHandler={backBtnHandler.bind(this)}
            value={props.searchText}
        />
    );

    const navigationViewContent = getNavigation();
    const navigationView = !initialFetchDone ? (
        <div className="navigation-live-skeleton-container">
            <HorizontalNavigationSkeleton />
        </div>
    ) : (
        <>{navigationViewContent}</>
    );

    const listViewContent = getContentWithSorting(activeSportId);
    const listView =
        !initialFetchDone || !contentWithSortingReady ? (
            <ViewEventListSkeleton keyword={'live'} />
        ) : (
            <>
                <ViewListToolbar title={selectedSport} isLive="true" />
                <>{listViewContent}</>
            </>
        );

    const widgetViewContent = getWidget(activeSportId);
    const widgetView = !initialFetchDone ? (
        <div className="secondary-block">
            <WidgetSkeleton />
        </div>
    ) : (
        <>{widgetViewContent}</>
    );

    return (
        <section className="live-page-layout home-layout">
            {searchInputView}
            {navigationView}
            <div className="main-content-container">
                <div className="main-block">{listView}</div>

                {!isMobile && widgetView}
            </div>
        </section>
    );
};

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        liveEvents: state.liveEvents,
        sportTree: state.sportTree,
        eventObject: state.eventObject,
        vaixEvents: state.vaixEvents,
        activeSportId: state.uiSportLive.activeSportId,
        liveEventsBySport: state.uiSportLive.liveEventsBySport,
        searchText: state.uiSportLive.searchText,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        eventObjectActions: bindActionCreators(EventObjectActions, dispatch),
        uiSportLiveActions: bindActionCreators(UiSportLiveActions, dispatch),
        liveEventsActions: bindActionCreators(LiveEventsActions, dispatch),
        vaixEventsActions: bindActionCreators(VaixEventsActions, dispatch),
        trackClickEvent: bindActionCreators(
            TrackingEventActions.trackClickEvent,
            dispatch
        ),
        trackImpressionEvent: bindActionCreators(
            TrackingEventActions.trackImpressionEvent,
            dispatch
        ),
        trackImpressionSport: bindActionCreators(
            TrackingEventActions.trackImpressionSport,
            dispatch
        ),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SectionLiveTab);
